import { useState } from "react";

interface FormUpdate {
  updateType: string;
  value: string;
}

interface UseFormReturn<T> {
  formData: T;
  errorMessage: string;
  loading: boolean;
  updateFormValue: (update: FormUpdate) => void;
  setErrorMessage: (message: string) => void;
  setLoading: (loading: boolean) => void;
}

function useForm<T>(initialState: T): UseFormReturn<T> {
  const [formData, setFormData] = useState<T>(initialState);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const updateFormValue = ({ updateType, value }: FormUpdate): void => {
    setErrorMessage("");
    setFormData({ ...formData, [updateType]: value });
  };

  return {
    formData,
    errorMessage,
    loading,
    updateFormValue,
    setErrorMessage,
    setLoading,
  };
}

export default useForm;
